import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { Papel, TipoCliente } from '@/stores/authStore';
import type { Surgery } from '@/lib/surgeries';

/**
 * Rótulos dos enums do backend, no idioma do app. Valor desconhecido mostra o próprio código.
 * "Administrador" e não "Admin do hospital": o cliente pode ser uma clínica ou um cirurgião particular.
 */

export const STATUS_CIRURGIA: Surgery['status'][] = ['Agendada', 'EmAndamento', 'Concluida', 'Cancelada'];

export function useRotulos() {
  const { t } = useTranslation('app_comum');
  return useMemo(() => {
    const rotulo = (grupo: string) => (codigo: string) => t(`rotulos.${grupo}.${codigo}`, { defaultValue: codigo });
    return {
      papel: rotulo('papel') as (p: Papel | string) => string,
      tipoCliente: rotulo('tipoCliente') as (t: TipoCliente | string) => string,
      statusCirurgia: rotulo('statusCirurgia') as (s: Surgery['status'] | string) => string,
      tipoNotificacao: rotulo('tipoNotificacao'),
    };
  }, [t]);
}
